// Firebase Configuration
// This file exports the Firebase configuration for use in other parts of the application

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// IMPORTANT: These are temporary values from the alluvion-embellishment project
// Replace these with your actual Firebase project configuration for production
export const firebaseConfig = {
  apiKey: "AIzaSyDgZUyHCdcO_QziqNL3Pn7nqqptiMwfxI4",
  authDomain: "dwds-shopify-automation.firebaseapp.com",
  projectId: "dwds-shopify-automation",
  storageBucket: "dwds-shopify-automation.appspot.com",
  messagingSenderId: "413686709652",
  appId: "1:413686709652:web:8e484c61c39a3598076381",
  measurementId: "G-MDLHKMTXQB",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Authentication
export const auth = getAuth(app);

// Initialize Functions
export const functions = getFunctions(app);

// Initialize Analytics only in browser environment
let analytics = null;
try {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
} catch (error) {
  console.warn("Analytics initialization failed:", error);
}
export { analytics };

// Determine if we're running on localhost
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// Configure Firebase services
console.log("Using production Firebase services");

// API Configuration
export const apiConfig = {
  // Always use production endpoints
  baseUrl: `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/`,
  // baseUrl: `http://localhost:5001/dwds-shopify-automation/us-central1/`,
  endpoints: {
    getShopifyOrderByNumber: "getShopifyOrderByNumber",
    getShopifyOrderById: "getShopifyOrderById",
    getShopifyOrders: "getShopifyOrders",
    getAllShopifyOrders: "getAllShopifyOrders",
    getUnfulfilledShopifyOrders: "getUnfulfilledShopifyOrders",
    handleReturnRequest: "handleReturnRequest",
    getReturnRequests: "getReturnRequests",
    generateShopifyOrdersReport: "generateShopifyOrdersReport",
    generateFulfilledOrdersReport: "generateFulfilledOrdersReport",
    generateUnfulfilledOrdersReport: "generateUnfulfilledOrdersReport",
  },
};

// Helper function to call Firebase Functions
export const callFunction = (name, data) => {
  const functionRef = httpsCallable(functions, name);
  return functionRef(data);
};

// Export a default object with all Firebase services and API configuration
export default {
  app,
  db,
  auth,
  functions,
  analytics,
  config: firebaseConfig,
  api: apiConfig,
  callFunction,
};
